module.exports = __webpack_public_path__ + "img/piggy.4fcd5068.png";